import React from 'react';
import {ConnectedRouter} from 'connected-react-router'
import {Provider} from 'react-redux';
import {Route, Switch,HashRouter} from 'react-router-dom';

import configureStore, {history} from './store';
import './firebase/firebase';
import App from './containers/App';

export const store = configureStore();

const MainApp = () =>
  <Provider store={store}>
    <ConnectedRouter history={history}>
      <HashRouter>
      <Switch>
        <Route path="/" component={App}/>
      </Switch>
      </HashRouter>
    </ConnectedRouter>
  </Provider>;


export default MainApp;